// Copyright 2025 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";
import { SorXMeasurement } from "datatypes/SorXMeasurement";
import { ReportTemplate } from "../../ReportTemplate";

@customElement("sorx-ld-report-template")
export class SorXLDReportTemplate extends ReportTemplate<SorXMeasurement> {
    private notAvailableString = "";

    @bindable
    public pageNumber: number;

    @bindable
    public maxPages: number;
}
